// Strings for S4. Only the S4 worker edits this file (see web/README.md).
// Copy from prototype/index.html and assets/app.js; DRAFT = no source there (w2-03 report).
export default {
  title: 'What happened?',
  titleFlight: 'What happened to {ident}?',
  sub: "Tell us what you experienced and we'll check it against the airline's data.",
  delayed: 'It was delayed',
  cancelled: 'It was cancelled',
  denied: 'I was denied boarding',
  diverted: 'It landed somewhere else',
  missed: 'I missed my connection',
  saveFailed: "That didn't save. Check your connection and try again.", // DRAFT
} as const;
